var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZeppelinCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.85729 2.85714C8.85729 2.38376 8.47353 2 8.00015 2C7.52676 2 7.143 2.38376 7.143 2.85714V4.57142H5.42857C3.53502 4.57142 2 6.10645 2 7.99999V11.4286V22.5714C2 24.465 3.53502 26 5.42857 26H22.5714C24.465 26 26 24.465 26 22.5714V11.4286V7.99999C26 6.10645 24.465 4.57142 22.5714 4.57142H20.8572V2.85714C20.8572 2.38376 20.4734 2 20 2C19.5266 2 19.1429 2.38376 19.1429 2.85714V4.57142H8.85729V2.85714ZM19.1429 8V6.28571H8.85729V8C8.85729 8.47339 8.47353 8.85715 8.00015 8.85715C7.52676 8.85715 7.143 8.47339 7.143 8V6.28571H5.42857C4.4818 6.28571 3.71429 7.05322 3.71429 7.99999V10.5714H24.2857V7.99999C24.2857 7.05322 23.5182 6.28571 22.5714 6.28571H20.8572V8C20.8572 8.47339 20.4734 8.85715 20 8.85715C19.5266 8.85715 19.1429 8.47339 19.1429 8ZM24.2857 22.5714V12.2857H3.71429V22.5714C3.71429 23.5182 4.4818 24.2857 5.42857 24.2857H22.5714C23.5182 24.2857 24.2857 23.5182 24.2857 22.5714ZM16.3571 16.0296V14.8571H11.6428V16.1675H14.4172L12.0913 21.1823L13.7705 21.7143L16.3571 16.0296Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZeppelinCalendarIcon);
export default __webpack_public_path__ + "static/media/zeppelin-calendar-icon.b3b2643e.svg";
export { ForwardRef as ReactComponent };